import LoginPasswordPage from './login-password-page';

export default LoginPasswordPage;
